import { render, staticRenderFns } from "./ClientsWidget.vue?vue&type=template&id=ac89a5a4&scoped=true"
import script from "./ClientsWidget.vue?vue&type=script&lang=js"
export * from "./ClientsWidget.vue?vue&type=script&lang=js"
import style0 from "./ClientsWidget.vue?vue&type=style&index=0&id=ac89a5a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac89a5a4",
  null
  
)

export default component.exports